import { combineReducers } from '@reduxjs/toolkit';
import { reducerListUser } from './ReducerListUser';
import { reducerListAuction } from './ReducerListAuction';

export const reducers = combineReducers({
  reducerListUser,
  reducerListAuction,
});
